import React from "react";
import { Enrolment } from "../../../../stores/EnrolmentStore/Types";
import { mastheadImage } from "../helpers";

interface Props {
  currentUser: any;
  enrolment: Enrolment;
}

const Masthead = ({ currentUser, enrolment }: Props) => {
  const course = enrolment?.course;
  const imageUrl = mastheadImage(enrolment, currentUser);

  return (
    <section className="masthead" aria-labelledby="course-title">
      <div className="masthead-bg" aria-hidden="true">
        {imageUrl && (
          <img
            src={imageUrl}
            alt=""
            width="1400"
            height="575"
            loading="eager"
            decoding="async"
          />
        )}
      </div>
      <div className="masthead-tint" aria-hidden="true"></div>
      <div className="container">
        <p className="eyebrow">
          {course?.tile_description || course?.content_live}
        </p>
        <h1 id="course-title">{course?.name || "Course overview"}</h1>
        {course?.thought_leader_name && (
          <p className="byline">With {course.thought_leader_name}</p>
        )}
      </div>
    </section>
  );
};

export default Masthead;
